import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import Keycloak from "keycloak-js";
import { catchError, throwError } from "rxjs";
import { NotificationService } from "../../services/notification.service";
import { ConfirmModalComponent } from "../../shared/confirm-modal/confirm-modal.component";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);
  const dialog = inject(MatDialog);
  const notify = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const dialogRef = dialog.open(ConfirmModalComponent, {
          width: "400px",
          data: {
            message: `La sessione è scaduta. Si deve effettuare nuovamente l'accesso.`,
            title: "Attenzione",
          },
        });
        dialogRef.afterClosed().subscribe(() => {
          keycloak.login();
        });
        
      } else if(error.status === 409) {
        notify.associatedEntityError(error.error.message);
      }
      return throwError(() => error);
    }),
  );
};
